import React from 'react';
import CurrencyService from '../Services/CurrencyService';
import ErrorMessage from './ErrorMessage';

export default class CurrencyLabelGenerator extends React.Component
{
    static defaultProps = {
        labelText: "",
        id: null,
    };

    constructor (props)
    {
        super(props);
        this.state = {
            currencyName: ""
        };
    }

    populateData ()
    {
        if (this.props.id)
        {
            CurrencyService.GetCurrencyCodeById(this.props.id)
                .then((result) =>
                {
                    ErrorMessage.LogDevInfo(result, "CLG29");
                    this.setState({ currencyName: `(${result})` });
                })
                .catch(error => ErrorMessage.SetErrorMessage("CLG29"));
            return;
        }
        this.setState({ currencyName: "" });
    }

    componentDidMount ()
    {
        this.populateData();
    }

    componentDidUpdate (prevProps)
    {
        if (prevProps !== this.props)
        {
            this.populateData();
        }
    }


    render ()
    {
        return this.props.labelText.replace('{Value}', this.state.currencyName);
    }
}
